<template>
  <StepContainer
    v-loading="isLoading"
    :title="$t('APPS.DRAFT.STEPS.SUPPORT_INFO')"
  >
    <SupportInfoForm v-model="supportInfo" :errors="fieldErrors" />
    <StepControllers slot="actions" @change-step="goToStep" />
  </StepContainer>
</template>

<script>
import StepContainer from '../common/StepContainer';
import SupportInfoForm from './SupportInfoForm';
import StepControllers from '../common/StepControllers';
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_DRAFT_APP_STATE, DRAFT_APP } from '@/store/types';

export default {
  name: 'SupportInfoStep',
  components: { StepContainer, SupportInfoForm, StepControllers },
  inject: ['stepperController'],
  data() {
    return {
      isLoading: false,
      fieldErrors: {},
      supportInfo: {
        phone: '',
        email: '',
        homepageFa: '',
        homepageEn: '',
      },
    };
  },
  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
  },
  watch: {
    draftApp: {
      immediate: true,
      handler(draftApp) {
        this.supportInfo = {
          phone: draftApp.phone,
          email: draftApp.email,
          homepageFa: draftApp.homepageFa,
          homepageEn: draftApp.homepageEn,
        };
      },
    },
  },
  created() {
    this.stepperController.onStepClick(this.goToStep);
  },
  beforeDestroy() {
    this.stepperController.removeOnStepClick(this.goToStep);
  },
  methods: {
    ...mapActions({ checkAndChangeStep: CHANGE_DRAFT_APP_STATE }),

    goToStep(step) {
      this.isLoading = true;
      this.fieldErrors = {};

      this.checkAndChangeStep({ to: step, data: this.supportInfo })
        .catch(({ message, errors = [], fieldErrors = {} }) => {
          this.$message.error(message);
          this.errors = errors;
          this.fieldErrors = fieldErrors;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
